var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCreateClaim(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#F5F8FD"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.5 12C18.5 11.4477 18.0523 11 17.5 11C16.9477 11 16.5 11.4477 16.5 12H18.5ZM16.5 28C16.5 28.5523 16.9477 29 17.5 29C18.0523 29 18.5 28.5523 18.5 28H16.5ZM15 13H25V11H15V13ZM27 15V25H29V15H27ZM25 27H15V29H25V27ZM13 25V15H11V25H13ZM15 27C13.8954 27 13 26.1046 13 25H11C11 27.2091 12.7909 29 15 29V27ZM27 25C27 26.1046 26.1046 27 25 27V29C27.2091 29 29 27.2091 29 25H27ZM25 13C26.1046 13 27 13.8954 27 15H29C29 12.7909 27.2091 11 25 11V13ZM15 11C12.7909 11 11 12.7909 11 15H13C13 13.8954 13.8954 13 15 13V11ZM16.5 12V28H18.5V12H16.5ZM12.5 18.5H27.5V16.5H12.5V18.5Z",
    fill: "#3062D4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreateClaim);
export default __webpack_public_path__ + "static/media/create-claim.73cc5f37bec1440caf86c91bcbe44e57.svg";
export { ForwardRef as ReactComponent };